module.exports = __webpack_public_path__ + "static/media/fundraiser-step-1.44622012.svg";